import { getLocalBaseURL } from "../utils/envVals";

export interface RouteConfig {
    path: string;
    remoteName: string;
    exposedModule: string;
    moduleName?: string;
    children?: string[];
    remoteEntry: string;
}

export interface RemoteRouteConfig extends RouteConfig {
    remoteEntry: string;
}

export enum RoutePaths {
    HOME = 'vision/',
    TRACK_TRACE = 'vision/track-trace/ambient',
    TRACK_TRACE_OLD = 'vision/track-trace',
    REPORTS_STACK = 'vision/reportsstack',
    BEACON = 'vision/beacon',
    BEACON_IMPORT_OPERATIONS = 'vision/beacon/importOperations',
    TRACKER_HOME = 'vision/tracker/events-home',
    TRACKER_EVENT_DETAIL = 'vision/tracker/events-home/event-detail',
    FC_INBOUND_HOME = 'vision/fc-inbound',
    FC_INBOUND_DOCK_TO_STOCK = 'vision/fc-inbound/dock-to-stock',
    TRACK_TRACE_AMBIENT = 'vision/track-trace/ambient',
    TRACK_TRACE_GROCERY = 'vision/track-trace/grocery',
    SDC_INBOUND = 'vision/sdc-inbound',
    // ─── Center Points standalone module ─────────────────────────────────────
    CENTER_POINTS = 'vision/center-points',
    CENTER_POINTS_IB = 'vision/center-points/inbound-loads',
    CENTER_POINTS_OB = 'vision/center-points/outbound-loads',
}

// Helper function to generate RouteConfig
const createRouteConfig = (path: string, moduleName: string, exposedModule: string): RouteConfig => {
    const hmPrt = path === RoutePaths.HOME ? '/vision' : '';
    const remoteEntry = `${getLocalBaseURL()}/web${hmPrt}/${moduleName}/remoteEntry.js`
    return {
        path,
        remoteName: 'remote',
        remoteEntry,
        exposedModule,
        moduleName,
    }
};

// RouteLookup with reduced redundancy
export const RouteLookup: Record<string, RouteConfig> = {
    [RoutePaths.HOME]: createRouteConfig(RoutePaths.HOME, 'home', './HomePageMap'),
    [RoutePaths.TRACK_TRACE]: createRouteConfig(RoutePaths.TRACK_TRACE, 'track-trace', './TrackAndTrace'),
    [RoutePaths.TRACK_TRACE_OLD]: createRouteConfig(RoutePaths.TRACK_TRACE_OLD, 'track-trace', './TrackAndTrace'),
    [RoutePaths.REPORTS_STACK]: createRouteConfig(RoutePaths.REPORTS_STACK, 'reports', './ReportsStack'),
    [RoutePaths.BEACON]: createRouteConfig(RoutePaths.BEACON, 'beacon', './Beacon'),
    [RoutePaths.BEACON_IMPORT_OPERATIONS]: createRouteConfig(RoutePaths.BEACON_IMPORT_OPERATIONS, 'beacon', './ImportOperations'),
    [RoutePaths.TRACKER_HOME]: createRouteConfig(RoutePaths.TRACKER_HOME, 'tracker', './EventTracker'),
    [RoutePaths.TRACKER_EVENT_DETAIL]: createRouteConfig(RoutePaths.TRACKER_EVENT_DETAIL, 'tracker', './EventTracker'),
    [RoutePaths.FC_INBOUND_HOME]: createRouteConfig(RoutePaths.FC_INBOUND_HOME, 'fc-inbound', './FCInbound'),
    [RoutePaths.FC_INBOUND_DOCK_TO_STOCK]: createRouteConfig(RoutePaths.FC_INBOUND_DOCK_TO_STOCK, 'fc-inbound', './FCInbound'),
    [RoutePaths.TRACK_TRACE_GROCERY]: createRouteConfig(RoutePaths.TRACK_TRACE_GROCERY, 'track-trace', './TrackAndTrace'),
    [RoutePaths.SDC_INBOUND]: createRouteConfig(RoutePaths.SDC_INBOUND, 'sdc-inbound', './SDCInbound'),
    // ─── Center Points standalone module ─────────────────────────────────────
    // All 3 paths load the same ./CenterPoints expose from the track-trace remote.
    // The React MFE (center-points-mfe) routes internally to the correct sub-page.
    [RoutePaths.CENTER_POINTS]: createRouteConfig(RoutePaths.CENTER_POINTS, 'track-trace', './CenterPoints'),
    [RoutePaths.CENTER_POINTS_IB]: createRouteConfig(RoutePaths.CENTER_POINTS_IB, 'track-trace', './CenterPoints'),
    [RoutePaths.CENTER_POINTS_OB]: createRouteConfig(RoutePaths.CENTER_POINTS_OB, 'track-trace', './CenterPoints'),
};
// Function to get a specific route configuration
export function getRemoteConfig(path: string): RemoteRouteConfig | undefined {
    return RouteLookup[path];
}